import { useNavigate } from 'react-router-dom';
import { useAddInteractionDictionaryMutation } from 'src/api/interactions-dictionary';
import { validateEmpty } from 'src/helpers/validators';
import { links } from 'src/router/routes';

export type FormData = {
  name: string;
};

const validate = {
  name: (value: string) => validateEmpty(value, 'Name is required'),
};

const initialValues: FormData = {
  name: '',
};

export const useAddInteractionDictionary = () => {
  const navigate = useNavigate();
  const { addInteractionDictionaryMutation, isPending } =
    useAddInteractionDictionaryMutation();

  const handleSubmit = async (values: FormData) => {
    try {
      const result = await addInteractionDictionaryMutation(values);

      if (result) {
        navigate(`${links.interactionDictionary}/${result.id}`);
      }
    } catch (error) {
      console.error(
        '[AddInteractionDictionary] Failed to create interaction dictionary:',
        error
      );
    }
  };

  const onCancel = () => {
    navigate(links.interactionDictionary);
  };

  return {
    handleSubmit,
    onCancel,
    initialValues,
    isPending,
    validate,
  };
};
